import React, { useEffect, useState } from 'react';
import { Space, Layout } from "antd";
import "./map.css";

export const MapJson = {"dutyname":"","dutyinf":""};

export default function MiniMap({ location , name }) {

    console.log("MiniMap location", location);

   const { kakao } = window;
   const [open, setOpen] = useState(false)
   const [level, setLevel] = useState(5);
   const [latitude, setLatitude] = useState(37.56482718);   
   const [longtude, setLongtude] = useState(126.9886721903);
   const [mapJson, setMapJson] = useState({})

   function onDismissClick() {
      setOpen(false)
   }   

   const [isModalOpen, setIsModalOpen] = useState(true);

    const showModal = () => {
        setIsModalOpen(true);
    };

    const handleOk = () => {
        setIsModalOpen(false);
    };

    const handleCancel = () => {
        setIsModalOpen(false);
    };

   var map;
   var mapTypeControl;
   var zoomControl;
   var clusterer;

   function mapInit(location , name ){        
        // 주소-좌표 변환 객체를 생성합니다
        const geocoder = new window.kakao.maps.services.Geocoder();
        const map = new window.kakao.maps.Map(document.getElementById('map'), {
            center: new window.kakao.maps.LatLng(latitude, longtude), // 초기 중심 좌표
            level: level, // 지도의 확대 레벨
            padding: 10,
            margin: 10
        });

        map.setDraggable(false);    
        map.setZoomable(false);  
       
        var mapContainer = document.getElementById('mapwrap');
        var isDragging = false;
        var startX, startY;
        mapContainer.addEventListener('touchstart', function(e) {
            isDragging = true;
            var touch = e.touches[0];
            startX = touch.clientX - mapContainer.offsetLeft;
            startY = touch.clientY - mapContainer.offsetTop;
        });
        
        mapContainer.addEventListener('touchmove', function(e) {
            if (isDragging) {
                var touch = e.touches[0];
                var deltaX = startX - touch.clientX;
                var deltaY = startY - touch.clientY;
                mapContainer.scrollLeft += deltaX;
                mapContainer.scrollTop += deltaY;
                startX = touch.clientX;
                startY = touch.clientY;
            }
        });
        
        mapContainer.addEventListener('touchend', function() {
            isDragging = false;
        });

        // 주소로 좌표를 검색합니다
        geocoder.addressSearch(location, function(result, status) {
            console.log("location", location);
            
            if (status === kakao.maps.services.Status.OK) {
                var coords = new kakao.maps.LatLng(result[0].y, result[0].x);
                // 결과값으로 받은 위치를 마커로 표시합니다
                var marker = new kakao.maps.Marker({
                    map: map,
                    position: coords
                });
                // 인포윈도우로 장소에 대한 설명을 표시합니다
                var infowindow = new kakao.maps.InfoWindow({
                    content: '<div style="width:150px;text-align:center;padding:6px 0;">'+name+'</div>'
                });
                infowindow.open(map, marker);
                // 지도의 중심을 결과값으로 받은 위치로 이동시킵니다
                map.setCenter(coords);
            } 
        });  
   }

   useEffect(() => {
       // Kakao Maps API가 로드되었는지 확인
       if (window.kakao && window.kakao.maps) {
           mapInit(location, name);
       } else {
           console.error('Kakao Maps API가 로드되지 않았습니다.');
       }
   }, [location, name]);

   return (
    <Space direction="vertical" style={{ width: "100%" }} size={[0, 48]}>
        <Layout>
            <div id="mapwrap" style={{ position: 'relative', width: '100%', height: '100vh', backgroundColor: 'white' }}> 
                <div id="map" style={{ position: 'absolute', top: 0, left: 10, width: 'calc(100% - 20px)', height: '100%', zIndex: 1 }}></div>  
                <div id="mapCover" style={{ position: 'absolute', top: 0, left: 10, width: 'calc(100% - 20px)', height: '100%',  zIndex: 2 }}>
                </div>           
            </div> 
        </Layout>
    </Space>
   )
}
